<template>
  <el-form
    label-position="top"
    :model="recipientInfoForm"
    ref="recipientInfoForm"
    :rules="rules"
    label-width="80px"
    size="normal"
  >
    <div test-id="main">
      <el-form-item label="Mobile Money Provider" prop="bankName">
        <el-select
          class="w-full"
          filterable
          remote
          v-model="recipientInfoForm.bankName"
          placeholder="Enter Provider Name"
          :remote-method="
            (query) => remoteMethodBanks(query, recipientInfoForm.bankCountry)
          "
          :loading="loading"
          @change="changeMobileMoneyProvider"
        >
          <el-option
            v-for="(provider, index) in formattedBankOptions"
            :key="index"
            :label="provider.name"
            :value="provider.name"
            @click.native="selectMoneyProviderCode(provider.code)"
          >
            {{ provider.name }}
          </el-option>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-select>
      </el-form-item>
      <div
        class="max-w-xl grid grid-cols-12 items-center justify-center gap-x-2"
      >
        <el-form-item label="Phone number" class="col-span-4">
          <el-select
            class="text-primary"
            v-model="recipientInfoForm.countryCode"
          >
            <template slot="prefix"> </template>
            <el-option
              v-for="item in currentCountryCode"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              class="w-full flex items-center"
            >
              <span>{{ item.label }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="col-span-8 mt-10 md:mt-10" prop="accountNo">
          <el-input
            min="1"
            @input="changeAccountNumber"
            v-model.trim="recipientInfoForm.accountNo"
            :placeholder="mobileMoneyPhoneNumberPlaceholder"
          ></el-input>
        </el-form-item>
      </div>
      <div
        class="flex flex-col"
        :class="hasProviderCodeOption ? 'md:grid md:grid-cols-4 gap-x-3' : ''"
      >
        <div v-if="hasProviderCodeOption" class="grid col-span-2">
          <el-form-item label="Provider Code" prop="bankCode">
            <el-input
              class="w-full"
              min="1"
              v-model.trim="recipientInfoForm.bankCode"
              placeholder="Enter Provider Code"
              readonly
            ></el-input>
          </el-form-item>
        </div>
        <div :class="hasProviderCodeOption ? 'grid col-span-2' : ''">
          <el-form-item label="Account Name" prop="accountName">
            <el-input
              class="w-full"
              min="1"
              v-model="recipientInfoForm.accountName"
              v-alpha-only
              placeholder="Enter Account Name"
              :readonly="isFallBackAccountName"
              type="text"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <el-button
        @click="validateWithdrawalForm('recipientInfoForm')"
        class="bg-primary w-full text-white font-normal rounded-lg py-5 shadow-lg"
        :disabled="isLoading"
        :loading="isLoading"
      >
        Continue
      </el-button>
    </div>
  </el-form>
</template>
<script>
import {
  COUNTRY_CODE_OPTIONS,
  GHS_MONEY_PROVIDER,
  XAF_MONEY_PROVIDERS,
  XOF_MONEY_PROVIDERS,
  PHONE_NUMBER_REGEX
} from '@/utils/constants.js'
import country from '@/mixins/getCountryDetails'
import {
  ValidateInput,
  GetCurrencyCountry,
  ValidateSingleSpace
} from '@/utils/helpers.js'
import terminal from '@/mixins/terminal.js'
import localDeposit from '@/mixins/localDeposit.js'
import tenant from '@/mixins/tenant.js'
export default {
  mixins: [country, terminal, localDeposit, tenant],
  components: {
    // CurrencyIcon: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  data () {
    return {
      loading: false,
      countryCodeOptions: COUNTRY_CODE_OPTIONS,
      ghsMoneyProviders: GHS_MONEY_PROVIDER,
      selectedCountryCode: '',
      isLoading: false,
      recipientInfoForm: {
        countryCode: '',
        accountNo: '',
        bankCode: '',
        accountName: ''
      },
      rules: {
        accountNo: [
          {
            required: true,
            message: 'Please input account number',
            trigger: ['blur', 'change']
          },
          {
            min: 7,
            message: 'Length should be at least 7 ',
            trigger: ['blur']
          },
          { validator: this.validateAccountNo, trigger: ['blur', 'change'] },
          { validator: ValidateSingleSpace, trigger: ['blur', 'change'] }
        ],
        accountName: [
          {
            required: true,
            message: 'Please input account name',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur'] }
        ],
        countryCode: [
          {
            required: true,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    validateWithdrawalForm (form) {
      this.isLoading = true
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.isLoading = false
          this.$emit('withdrawalAccountHandler', this.recipientInfoForm)
        } else {
          this.isLoading = false
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing information',
            position: 'top-right'
          })
        }
      })
    },
    validatePhoneNumber (rule, value, callback) {
      if (!PHONE_NUMBER_REGEX.test(value)) {
        callback(new Error('Please enter a valid number'))
      } else {
        callback()
      }
    },
    selectMoneyProviderCode (code) {
      this.recipientInfoForm.bankCode = code
      // this.recipientInfoForm.providerCode = code
    },
    changeMobileMoneyProvider () {
      this.recipientInfoForm.countryCode = ''
      if (
        this.computeValidAccountNumberLength(
          this.recipientInfoForm.accountNo.length
        )
      ) {
        this.resolveMoneyProviderAccountName(this.recipientInfoForm.accountNo)
      } else {
        this.recipientInfoForm.accountNo = ''
      }
    },
    async resolveMoneyProviderAccountName (phoneNo) {
      this.resolveAccountNameCore(phoneNo)
    },
    changeAccountNumber () {
      this.isAccountNameError = ''
    }
  },
  computed: {
    hasProviderCodeOption () {
      return this.secondaryCurrencyIsGHS
    },
    francMoneyProviders () {
      let providers = []
      if (this.secondaryCurrencyIsXAF) {
        providers = XAF_MONEY_PROVIDERS
      } else if (this.secondaryCurrencyIsXOF) {
        providers = XOF_MONEY_PROVIDERS
      }
      return providers
    }
  }
}
</script>
